module.exports = __webpack_public_path__ + "img/5.77d6e222.png";